export const DummyOtherIncomeSourceId = "newOtherIncome999";

export enum OtherIncomeSourceFields {
    Id = "id",
    Description = "description",
    MonthlyAmount = "monthlyAmount",
    Owner = "owner",
    IsNew = "isNew"
}